import { Box, Container } from '@mui/material';
import "./SectionWrapper.css"

export default function SectionWrapper({ children, backgroundColor = 'transparent', background = '', sx = {} }) {
    return (
        <Box className='section-wrapper' sx={{ width: '100%', bgcolor: backgroundColor, background: background, ...sx }}>
            <Container
                className='section-wrapper-content'
                maxWidth={false}
                sx={{
                    padding: 0,
                    mx: 'auto',
                }}
                style={{padding: 0}}
            >
                {children}
            </Container>
        </Box>
    );
}